/**
 * Gli orari del banco Datacom: lun-ven, 9:00-13:00 e 15:00-18:00 (Davide, 08/09/2026; prima 14:30-17:00).
 *
 * Sono gli orari del PC dell'ufficio (Davide, 01/09/2026). Il controllo usa
 * l'ora del telefono: gli installatori Datacom stanno in Italia, e sbagliare
 * di un'ora il cartellino "aperto/chiuso" per un utente in vacanza all'estero
 * e' un danno minore che portarsi dietro una libreria di fusi orari.
 */

export interface StatoBanco {
  aperto: boolean;
  /** Frase pronta per l'interfaccia. */
  messaggio: string;
}

const FASCE: Array<[number, number]> = [
  [9 * 60, 13 * 60],
  [15 * 60, 18 * 60],
];

export function statoBanco(adesso: Date = new Date()): StatoBanco {
  const giorno = adesso.getDay(); // 0=domenica, 6=sabato
  const minuti = adesso.getHours() * 60 + adesso.getMinutes();
  const feriale = giorno >= 1 && giorno <= 5;
  const inFascia = FASCE.some(([da, a]) => minuti >= da && minuti < a);

  if (feriale && inFascia) {
    return { aperto: true, messaggio: "Il banco è aperto: ti rispondiamo ora." };
  }
  return {
    aperto: false,
    messaggio:
      "Il banco ora è chiuso (lun-ven 9:00-13:00 e 15:00-18:00). Scrivi pure: ti rispondiamo alla riapertura.",
  };
}
